import React from 'react';
import { ChevronRight, Layers } from 'lucide-react';

export default function FractalBreadcrumb({ stack, onNavigate }) {
  if (!stack || stack.length <= 1) return null;

  return (
    <div className="flex items-center gap-1 px-3 py-2 bg-[#0a0b0e] border border-white/5 rounded-sm overflow-x-auto">
      <Layers className="w-3.5 h-3.5 text-[#f5b400] flex-shrink-0" />
      {stack.map((level, i) => {
        const isLast = i === stack.length - 1;
        return (
          <React.Fragment key={i}>
            {i > 0 && <ChevronRight className="w-3 h-3 text-[#4b5563] flex-shrink-0" />}
            <button
              onClick={() => !isLast && onNavigate(i)}
              className={`fractal-breadcrumb-enter px-2 py-0.5 rounded text-[10px] font-mono font-bold tracking-wider whitespace-nowrap transition-colors ${
                isLast
                  ? 'text-[#f5b400] bg-[#f5b400]/10 border border-[#f5b400]/20 cursor-default'
                  : 'text-[#8b93a7] hover:text-[#d1d5db] hover:bg-white/5 cursor-pointer'
              }`}
              disabled={isLast}
            >
              {level.label}
            </button>
          </React.Fragment>
        );
      })}
    </div>
  );
}
